<template>
  <div>
    <div class="my-inspections" ref="inspectionsLoader" v-show="loaded">
      <div>
        <vue-headful title="My Inspections"/>
        <h1>MY INSPECTIONS</h1>
        <hr/>
        <MyInspectionsLoader v-if="apiLoading"/>
        <InspectionList v-if="apiLoaded" :hg-inspections="inspections"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import MyInspectionsLoader from '@/components/Loaders/MyInspectionsLoader.vue';
import InspectionList from '../Inspection/InspectionList.vue';

export default {
  name: 'hgInspections',
  extends: BaseViewComponent,
  components: {
    InspectionList,
    MyInspectionsLoader,
  },
  async mounted() {
    await this.retrieveInspections(false);
  },
  computed: {
    ...mapState({
      loaded: state => state.loaded,
    }),
    ...mapState('Inspection', {
      inspections: state => state.inspections,
    }),
  },
  methods: {
    async retrieveInspections(doRedirect) {
      const { currentUser } = this.$store.state.User;
      const hydrationResponse = await this.initialHydration([
        this.$store.dispatch('Inspection/loadInspections', currentUser.legacyId),
      ]);
      if (!doRedirect
        || (!hydrationResponse || !hydrationResponse[0] || !hydrationResponse[0].folders)) {
        return;
      }
      if (hydrationResponse[0].folders.length === 1) {
        this.redirectToInspection(hydrationResponse[0].folders[0].id);
      }
    },
    redirectToInspection(inspectionId) {
      this.$router.push({
        name: 'inspection',
        params: {
          folderId: `${inspectionId}`,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';

hr {
  border: solid 2px $theme-color-primary;
  margin-top: 40px;
  width: 100%;
}

.my-inspections {
  padding: 50px;
}

@media all and (max-width: 655px) {
  .my-inspections {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
